import ReactMounter from 'lib/ReactMounter'
import LeipzigPage from 'pages/InvestmentLocations/LeipzigPage/LeipzigPage'

ReactMounter.registerComponentToMountOnLoad('LeipzigPage', LeipzigPage)
